import config from '../config'
import {
  IPaginatedSport8RefundAuditParams,
  IPaginatedSport8RefundAuditsResponse,
  ISport8RefundAudit,
} from '../pages/sport8-refund-audits-container/share-type'
import { Sport8StudioDto } from '../pages/sport8-studio-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getSport8Studio = (name: string | null, studioId: string | null) =>
  authRequest.get<MISSING_TYPE, Sport8StudioDto>(`${mainApi}/sport8/studio`, {
    params: { name, studioId },
  })

export const getSport8RefundAudits = (data: IPaginatedSport8RefundAuditParams) =>
  authRequest.get<MISSING_TYPE, IPaginatedSport8RefundAuditsResponse>(
    `${mainApi}/sport8/refund-audits`,
    {
      params: data,
    },
  )

export const getSport8RefundAudit = (bookingId: number) =>
  authRequest.get<MISSING_TYPE, ISport8RefundAudit>(`${mainApi}/sport8/refund-audits/${bookingId}`)

export const getSport8RefundAuditStatus = (bookingId: number) =>
  authRequest.get<MISSING_TYPE, string>(`${mainApi}/sport8/refund-audits/status/${bookingId}`)

export const createSport8RefundAudit = (
  bookingId: number,
  refundReasonCode: number,
  refundReason: string,
) =>
  authRequest.post<MISSING_TYPE, string>(`${mainApi}/sport8/refund-audits/${bookingId}`, {
    refundReasonCode,
    refundReason,
  })
